/**
 * Budgets Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const budgetsAPI = {
  getAll: (params) => apiClient.get('/budgets', { params }),
  getWithActuals: (params) => apiClient.get('/budgets/with-actuals', { params }),
  get12MonthOverview: (params) => apiClient.get('/budgets/12-month-overview', { params }),
  getById: (id) => apiClient.get(`/budgets/${id}`),
  create: (data) => apiClient.post('/budgets', data),
  createBulk: (data) => apiClient.post('/budgets/bulk', data),
  update: (id, data) => apiClient.put(`/budgets/${id}`, data),
  delete: (id) => apiClient.delete(`/budgets/${id}`),
};

export default budgetsAPI;

